// extracted by mini-css-extract-plugin
export default {"icons":"styles_icons_bXAzc","children":"styles_children_tMcE_","actions":"styles_actions_GHO25"};